export default "__VITE_ASSET__b9c50994__"